/* eslint-disable @typescript-eslint/naming-convention -- x */

/* eslint-disable @typescript-eslint/consistent-type-assertions -- x */
import { composeLink } from '../utils/links';
import { SharingActionType } from './SharingActionType';
import { SharingCapability } from './SharingCapabilities';
const {
  ShareText,
  ShareUrl,
  ShareUrlAndText
} = SharingCapability;
export const sharingVendorsConfig = {
  // copy link "vendor" at 1st place here - even the object defined as const could hold the order
  // on/off configuration for this doesn't come from the endpoint (probably) - TO-DO: verify Sitecore settings
  // it is enabled via the isCopyLinkIconDisplayed parameter when calling the share() method
  link: {
    actionType: SharingActionType.CopyLinkDialog,
    capabilities: [ShareUrl],
    // just return the original link that is to be shared
    getSharingLink: ({
      url
    }) => url,
    integrationKey: 'link'
  },
  blogger: {
    capabilities: [ShareText, ShareUrl, ShareUrlAndText],
    // https://www.blogger.com/blog-this.g?u={url}&n={title}&t={message}
    // http://www.blogger.com/blog_this.pyra?t=&amp;u={url}&amp;n={title} TO-DO is this the correct URL?
    // AddThis seems to go to blog_this.pyra
    getSharingLink: ({
      message,
      url
    }) => composeLink('https://www.blogger.com/blog-this.g', {
      n: url,
      // this is used as the visible link text, if empty, link will be missing in the post
      t: message,
      u: url
    }),
    integrationKey: 'blogger'
  },
  douban: {
    // http://www.douban.com/recommend/?name={title}&text={text}&comment={url}&href={url}
    // double URL placeholder? - TO-DO
    // TO-DO: Doesn't work as of 2021-11-04
    // getSharingLink: ({ message, title, url }) =>
    // 	composeLink(
    // 		'https://www.douban.com/recommend',
    // 		{
    // 			comment: url,
    // 			href: url,
    // 			name: title,
    // 			text: message,
    // 		},
    // 	),
    integrationKey: 'douban'
  },
  email: {
    actionType: SharingActionType.DirectNavigation,
    capabilities: [ShareText, ShareUrl, ShareUrlAndText],
    // mailto:{email_address}?subject={title}&body={message} {url}
    // Should we have 'from' (email_address) parameter? - TO-DO
    getSharingLink: ({
      isUrlDeduplicationRequired,
      message,
      title,
      url
    }) => composeLink('mailto:', {
      body: `${message}${isUrlDeduplicationRequired ? '' : `\n \n${url} `}\n `,
      subject: title
    }),
    integrationKey: 'email'
  },
  facebook: {
    capabilities: [ShareUrl],
    // https://www.facebook.com/sharer.php?u={url}&quote={message}
    // quote parameter is undocumented
    getSharingLink: ({
      message,
      url
    }) => composeLink('https://www.facebook.com/sharer/sharer.php', {
      quote: message,
      u: url
    }),
    integrationKey: 'facebook'
  },
  instagram: {
    // no sharing on instagram via simple link
    // but they have some APIs to upload media (seems very restricted though)
    integrationKey: 'instagram'
  },
  line: {
    capabilities: [ShareUrl, ShareUrlAndText],
    // https://social-plugins.line.me/lineit/share?url={url}&text={message}
    // parameters are undocumented
    // must be logged-in to share, didn't test further
    getSharingLink: ({
      message,
      url
    }) => composeLink('https://social-plugins.line.me/lineit/share', {
      text: message,
      url
    }),
    integrationKey: 'lineme'
  },
  messenger: {
    capabilities: [ShareUrl],
    // http://www.facebook.com/dialog/send?app_id={appId}&link={url}&redirect_uri={redirectUri}
    // FB App ID needed when using other Facebook sharing methods than sharer.php.
    //
    // Sitecore:
    // item path: /sitecore/content/Configuration/Social/Facebook
    //
    // Endpoints returning Sitecore sharing config (API or legacy AJAX call) don't return
    // vendor-specific info like App ID. It is probably quicker to hard-code here
    // and optionally adjust when some changes happen to the setting.
    //
    // Redirect URI needs to be filled-in, otherwise it screams error while sharing.
    //
    // Message in the dialog can't be prefilled according to policies, thus only URL sharing.
    // See https://stackoverflow.com/questions/25835817/custom-message-in-fb-share-dialog.
    getSharingLink: ({
      url
    }) => composeLink('http://www.facebook.com/dialog/send', {
      app_id: '209104039103989',
      redirect_uri: window.location.origin,
      link: url
    }),
    integrationKey: 'messenger'
  },
  odnoklassniki: {
    // https://connect.ok.ru/dk?st.cmd=WidgetSharePreview&st.shareUrl={url} - seems to work
    // wants to login first, not investigated further
    // https://connect.ok.ru/offer?url={url}&title={title}&imageUrl={image} - returned 404
    // TO-DO: Doesn't work as of 2021-11-04.
    // getSharingLink: ({ url }) =>
    // 	composeLink(
    // 		'https://connect.ok.ru/dk?st.cmd=WidgetSharePreview',
    // 		{
    // 			'st.shareUrl': url,
    // 		},
    // 	),
    integrationKey: 'odnoklassniki_ru'
  },
  pinterest: {
    capabilities: [ShareUrl],
    // http://pinterest.com/pin/create/link/?url={url}&media={image}&description={message}
    getSharingLink: ({
      message,
      url
    }) => composeLink('http://pinterest.com/pin/create/link', {
      description: message,
      url
    }),
    integrationKey: 'pinterest_share'
  },
  qq: {
    capabilities: [ShareUrl, ShareUrlAndText],
    // https://connect.qq.com/widget/shareqq/index.html?url={url}&title={title}&source={source}&desc={desc}&pics={image}&summary={summary}
    // returns page with a QR code on desktop, probably OK
    getSharingLink: ({
      message,
      title,
      url
    }) => composeLink('https://connect.qq.com/widget/shareqq/index.html', {
      desc: message,
      title,
      url
    }),
    integrationKey: 'tencentqq'
  },
  qzone: {
    capabilities: [ShareUrl],
    // http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url={url}&title={title}&desc={message}&summary={summary}&site={source}&pics={image}
    // http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url={url}&title={title}&summary={message}
    // Doesn't work as of 2022-09-23. TO-DO: re-check
    getSharingLink: ({
      message,
      title,
      url
    }) => composeLink('https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey', {
      desc: message,
      // or summary?
      title,
      url
    }),
    integrationKey: 'qzone'
  },
  renren: {
    // http://widget.renren.com/dialog/share?resourceUrl={url}&srcUrl={url}&title={title}&description={text}
    // TO-DO: Doesn't work as of 2021-11-04.
    // getSharingLink: ({ message, title, url }) =>
    // 	composeLink(
    // 		'http://widget.renren.com/dialog/share',
    // 		{
    // 			description: message,
    // 			title,
    // 			resourceUrl: url, // or srcUrl ?
    // 		},
    // 	),
    integrationKey: 'renren'
  },
  rss: {},
  telegram: {
    capabilities: [ShareUrl, ShareUrlAndText],
    // https://t.me/share/url?url={url}&text={text}
    getSharingLink: ({
      message,
      url
    }) => composeLink('https://t.me/share/url', {
      text: message,
      url
    }),
    integrationKey: 'telegram'
  },
  tqq: {
    // this tqq looks like tencentweibo, which, according
    // to this info https://en.wikipedia.org/wiki/Tencent_Weibo
    // was shut down in 2020, so only QQ from Tencent works here now
  },
  twitter: {
    capabilities: [ShareText, ShareUrl, ShareUrlAndText],
    // https://twitter.com/intent/tweet?url={url}&text={title}&via={user_id}&hashtags={hash_tags}
    getSharingLink: ({
      message,
      url
    }) => composeLink('https://twitter.com/intent/tweet', {
      text: message,
      url
    }),
    integrationKey: 'twitter'
  },
  vkontakte: {
    capabilities: [ShareText, ShareUrl, ShareUrlAndText],
    // https://vk.com/share.php?url=${url}&description=${message}
    // looks like these params should be supported (source https://github.com/720kb/angular-socialshare/issues/105):
    // url - Link to the page to be posted.
    // title - Post title. If not set, title from the post page will be used.
    // description - Post description. If not set, description from the post page will be used.
    // image - Link to image of the post. If not set, image from the post page will be used.
    // noparse - If true, VK server will not make an additional request to download missing information from the posted page. If false, request will be sent always.
    // no_vk_links - If the value is 1, there will be no active links to VK in the post window.
    // similar info at https://github.com/nygardk/react-share/blob/master/src/VKShareButton.ts
    // docs: https://vk.com/dev/widget_share (check RU version - additional params described only there)
    // the description param is missing in latest RU docs
    getSharingLink: ({
      message,
      url
    }) => composeLink('https://vk.com/share.php', {
      title: message,
      noparse: 1,
      url
    }),
    integrationKey: 'vk'
  },
  wechat: {
    actionType: SharingActionType.CopyLinkDialog,
    // The WeChat-associated weixin:// URL scheme doesn't work
    // in normal web browser & is only understood by the app.
    // Usual workaround solution is to display a QR code with link
    // to be scanned & opened via mobile app.
    integrationKey: 'wechat'
  },
  weibo: {
    capabilities: [ShareUrl, ShareUrlAndText],
    // probably newer, requires appkey: http://service.weibo.com/share/share.php?url={url}&appkey=&title={title}&pic=&ralateUid=
    // probbly older: http://service.weibo.com/share/share.php?url={url}&title={title}&source={source}&desc={desc}&pic={image}&summary={summary}
    // TO-DO: Is app key needed?
    getSharingLink: ({
      message,
      title,
      url
    }) => composeLink('https://service.weibo.com/share/share.php', {
      desc: message,
      title,
      url
    }),
    integrationKey: 'sinaweibo'
  },
  whatsapp: {
    capabilities: [ShareText, ShareUrl, ShareUrlAndText],
    // https://api.whatsapp.com/send?phone={phone_number}&text={message}
    getSharingLink: ({
      isUrlDeduplicationRequired,
      message,
      url
    }) => composeLink('https://api.whatsapp.com/send', {
      text: `${message}${isUrlDeduplicationRequired ? '' : `\n\n${url}`}`
    }),
    integrationKey: 'whatsapp'
  },
  youku: {},
  youtube: {}
};
//# sourceMappingURL=sharingVendorsConfig.js.map